import { Icon, IconProps } from "@chakra-ui/react";

/**
 * Closed-padlock glyph — used to mark private reading lists and other
 * "owner-only" surfaces. Matches the stroke weight of EyeIcon /
 * EyeBlindIcon so the same row can mix visibility variants without one
 * pill reading heavier than another. 24×24 viewBox to match the rest of
 * the icon library; render at any size via Chakra's w/h props.
 */
export function LockIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.5C9.51472 2.5 7.5 4.51472 7.5 7V10H6.5C5.39543 10 4.5 10.8954 4.5 12V19.5C4.5 20.6046 5.39543 21.5 6.5 21.5H17.5C18.6046 21.5 19.5 20.6046 19.5 19.5V12C19.5 10.8954 18.6046 10 17.5 10H16.5V7C16.5 4.51472 14.4853 2.5 12 2.5ZM15.5 10V7C15.5 5.067 13.933 3.5 12 3.5C10.067 3.5 8.5 5.067 8.5 7V10H15.5ZM6.5 11C5.94772 11 5.5 11.4477 5.5 12V19.5C5.5 20.0523 5.94772 20.5 6.5 20.5H17.5C18.0523 20.5 18.5 20.0523 18.5 19.5V12C18.5 11.4477 18.0523 11 17.5 11H6.5ZM12 13.75C11.3096 13.75 10.75 14.3096 10.75 15C10.75 15.4815 11.0223 15.8994 11.4209 16.1085L11 18H13L12.5791 16.1085C12.9777 15.8994 13.25 15.4815 13.25 15C13.25 14.3096 12.6904 13.75 12 13.75Z"
        fill="currentColor"
      />
    </Icon>
  );
}
